export const AUTH_TOKENS = {
  token: "auth_token",
  name: "user_name",
  company: "company_name",
  role: "user_role",
  mixLayout: "mix_layout",
  adminMode: "admin_mode",
  isNew: "is_new",
};
